import { useEffect, useState, useContext } from 'react';
import { useT } from '@transifex/react';
import { useIntl } from 'react-intl';
import { useFeatureFlag, getDistributor } from '@raisin/cp-utils';
import { HeaderDataContext, HeaderData } from '@raisin/cp-layout';
import { Offers } from 'types';
import { METHODS, createAsyncAction } from 'api';
import { MICROSERVICES_NAMES } from 'api/types';
import { transformOffersDataResponse } from 'utils/BIPSMappingToOBS';
import { getDistributionChannelId } from 'utils/getDistributionChannel';
import { getAuthorizationToken } from 'api/utils';

export const useOffersData = (locale: string, isLoggedIn: boolean) => {
  const [offersData, setOffersData] = useState<Offers>();
  const { formatNumber, formatDate } = useIntl();
  const t = useT();
  const { customerData = null } = useContext(HeaderDataContext) as HeaderData;
  const { isLoading: isFeatureFlagLoading } = useFeatureFlag();
  const { distributionChannelId, distributorId } = customerData || {};

  useEffect(() => {
    const defaultParams = {
      distributor_id: getDistributor(),
      distribution_channel_id: getDistributionChannelId(locale),
    };

    const headers = isLoggedIn ? { authorization: getAuthorizationToken() } : undefined;
    const params = {
      distributor_id: isLoggedIn && distributorId ? distributorId : defaultParams.distributor_id,
      distribution_channel_id:
        isLoggedIn && distributionChannelId
          ? distributionChannelId
          : defaultParams.distribution_channel_id,
    };

    const settings = { params, headers };

    const fetchOffersData = async () => {
      const apiToRequestOffers = isLoggedIn ? 'dbs.privateProducts' : 'dbs.products';

      const data = await createAsyncAction(
        locale,
        MICROSERVICES_NAMES.DBS,
        apiToRequestOffers,
        METHODS.GET,
        settings,
      );

      setOffersData(transformOffersDataResponse(data, formatNumber, t, formatDate, locale));
    };

    if (isFeatureFlagLoading || (isLoggedIn && !distributorId)) return;
    fetchOffersData();
  }, [
    locale,
    isFeatureFlagLoading,
    isLoggedIn,
    formatNumber,
    t,
    formatDate,
    distributorId,
    distributionChannelId,
  ]);

  return { offersData };
};
